/* eslint-disable react-hooks/exhaustive-deps */
import { PermissionNameEnum } from '@Types/permissions';
import { usePermissionStore } from '@Models/usePermissionModel';
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Space,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormInput,
  FormLabel,
  FormTextarea,
} from 'src/components/Common/FormComponent';

const EditNotificationModal = (props: {
  isVisible: boolean;
  onClose: () => void;
  config: {
    ntfWritingStyleToAdminAccount: string;
    ntfWritingStyleAdministratorSubject: string;
    ntfWritingStyleAdministratorMessage: string;
  };
  saveConfig: (config: {
    ntfWritingStyleToAdminAccount: string;
    ntfWritingStyleAdministratorSubject: string;
    ntfWritingStyleAdministratorMessage: string;
  }) => void;
}) => {
  const {
    isVisible,
    onClose,
    config: {
      ntfWritingStyleToAdminAccount,
      ntfWritingStyleAdministratorSubject,
      ntfWritingStyleAdministratorMessage,
    },
    saveConfig,
  } = props;
  const { widthEditablePermission } = usePermissionStore();
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  const [account, setAccount] = React.useState(ntfWritingStyleToAdminAccount);
  const [subject, setSubject] = React.useState(
    ntfWritingStyleAdministratorSubject
  );
  const [message, setMessage] = React.useState(
    ntfWritingStyleAdministratorMessage
  );
  const onSave = React.useCallback(() => {
    const config = {
      ntfWritingStyleToAdminAccount: account,
      ntfWritingStyleAdministratorSubject: subject,
      ntfWritingStyleAdministratorMessage: message,
    };
    saveConfig(config);
    onClose();
  }, [account, subject, message]);

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={isVisible}
      onClose={onClose}
      size="lg"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent backgroundColor={colorStyle.background.secondary}>
        <ModalHeader>{t('policy.actionAndNotification')}</ModalHeader>

        <ModalBody ml="24px" mt="16px" mb="16px">
          <Flex direction="column">
            <Flex mb="16px">
              <Text>{t('policy.label.notifyAdmin')}</Text>
            </Flex>
            <Flex mb="16px">
              <FormLabel label={t('policy.editNotification.to')} />
              <FormInput
                placeholder={t('policy.editNotification.toObject')}
                value={account}
                maxLength={255}
                width="600px"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  console.log(e.target.value);
                  setAccount(e.target.value);
                }}
              />
            </Flex>
            <Flex mb="16px">
              <FormLabel label={t('policy.editNotification.subject')} />
              <FormInput
                placeholder={t('policy.editNotification.subjectObject')}
                value={subject}
                maxLength={200}
                width="600px"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  console.log(e.target.value);
                  setSubject(e.target.value);
                }}
              />
            </Flex>
            <Flex>
              <FormLabel label={t('policy.editNotification.message')} />
              <FormTextarea
                value={message}
                width="600px"
                onChange={(e) => {
                  console.log(e.target.value);
                  setMessage(e.target.value);
                }}
              />
            </Flex>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            minWidth="20x"
            onClick={onSave}
            disabled={!widthEditablePermission(PermissionNameEnum.atpPolicy)}
          >
            {t('common.button.save')}
          </Button>
          <Space width="2x" />
          <Button minWidth="20x" onClick={() => onClose()}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default React.memo(EditNotificationModal);
